<template>
  <QuadroPrincipal
    v-if="dadosResultado.id_imposto == 100"
    class="difal-container"
    :classe="classe"
    :titulo="'CONTRIBUINTE'"
  >
    <Registro>
      <div :key="getRenderKey">
        <Cabecalho paddingBottom :titulo="dadosResultado.label" />
        <Inaplicabilidade :texto="dadosResultado.texto_inaplicabilidade" />
      </div>
    </Registro>
  </QuadroPrincipal>

  <QuadroPrincipal v-else :classe="classe" :titulo="'CONTRIBUINTE'">
    <Registro paddingSemCheckBox>
      <div :key="getRenderKey">
        <Descricao :titulo="dadosResultado.titulo" :descricao="dadosResultado.mensagem" />
        <div v-if="dadosResultado.titulo" class="separador" />
        <Cabecalho
          v-if="dadosResultado.atribuicao_responsabilidade"
          titulo="Atribuição de Responsabilidade"
          :aliquota="dadosResultado.atribuicao_responsabilidade"
        />
        <div v-if="dadosResultado.atribuicao_responsabilidade" class="separador" />
        <Cabecalho
          v-if="dadosResultado.base_calculo"
          paddingBottom
          titulo="Base de Cálculo DIFAL:"
          :aliquota="dadosResultado.base_calculo"
        />
        <div
          v-if="dadosResultado.base_calculo && dadosResultado.base_legal_base_calculo"
          class="separador"
        />
        <BaseLegal
          v-if="dadosResultado.base_legal_base_calculo"
          :base_legal="dadosResultado.base_legal_base_calculo"
          :classe="classe"
        />
        <div
          v-if="dadosResultado.base_legal_base_calculo || dadosResultado.base_calculo"
          class="separador"
        />
        <Cabecalho tipo="gnre" titulo="Guia de Recolhimento:" :aliquota="dadosResultado.guia_recolhimento"  :linkGnre="dadosResultado.link_guia_recolhimento"/>
        <div v-if="dadosResultado.guia_recolhimento" class="separador" />

        <Notificacao v-if="dadosResultado.alerta" :tipo="'alerta'" :texto="dadosResultado.alerta" />
        <GrupoNotificacao v-if="dadosResultado" :registro="dadosResultado" />

        <div
          v-if="dadosResultado.obs_aplic || dadosResultado.obs_inaplic || dadosResultado.obs"
          class="separador"
        />
        <BaseLegal
          v-if="dadosResultado.base_legal"
          :base_legal="dadosResultado.base_legal"
          :classe="classe"
        />
      </div>
    </Registro>
  </QuadroPrincipal>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import Inaplicabilidade from "@/components/Inaplicabilidade/Inaplicabilidade.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import QuadroZebra from "@/components/QuadroZebra/QuadroZebra.vue";
import Registro from "@/components/Registro/Registro.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import Observacoes from "@/components/Observacoes/Observacoes.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";
import { mapGetters } from "vuex";

export default {
  name: "ResultadoDifal",

  mixins: [stringFormatMixin],

  props: {
    dados: Object | Array
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    Inaplicabilidade,
    QuadroPrincipal,
    QuadroZebra,
    GrupoNotificacao,
    Registro,
    // RegistrosMva,
    Notificacao,
    Observacoes,
    Ncm
  },

  data() {
    return {
      classe: "icms_st"
      // selecionouMva: false
    };
  },

  // watch: {
  //   selecionouMva() {
  //     this.$emit("selecionaMva", this.selecionouMva);
  //   }
  // },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),
    dadosResultado() {
      return this.dados.dados[0];
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.registro-content {
  margin-bottom: 7px;

  label {
    margin-bottom: 2rem;
    font-size: 1rem;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

@media only print {
  .difal-container {
    padding-left: 10px;
    page-break-inside: avoid !important;
  }
}
</style>
